import EfScrollAni from '@/efscrollani';
import ProductNav from '../../common/ProductNav';
import { useProductStore } from '../../ProductProvider';
import { IPageStatus } from '../../config/IPageStatus';
import StatusA from './StatusA';
import StatusB from './StatusB';
import StatusC from './StatusC';
import './index.scss';

export default function ExampleProductA() {
    const { pageStatus } = useProductStore();

    if (typeof window !== 'undefined' && !window.AniContainer) {
        window.AniContainer = new EfScrollAni();
    }

    return (
        <div className="page-product">
            <ProductNav activeTab={'Product'} />
            {pageStatus === IPageStatus.statusA && <StatusA />}
            {pageStatus === IPageStatus.statusB && <StatusB />}
            {pageStatus === IPageStatus.statusC && <StatusC />}
        </div>
    );
}
